import React from "react";
import {round} from "lodash";

export const AdminBillingToBeReceivedSummaryLine = ({toBeReceivedOn, sumTotal}) => {
    return (
        <div
            style={{
                marginTop: 30,
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                backgroundColor: "rgba(18,96,209,0.1)",
                height: 70,
                borderRadius: 10,
                padding: 20
            }}>
            <div>
                <span style={{fontSize: 28, fontWeight: 700, color: "#1260D1", marginRight: 6}}>Sum total</span>
                <span style={{fontSize: 20, fontWeight: 400, color: "#1260D1"}}>
                    to be received on {toBeReceivedOn}
                </span>
            </div>
            <div>
                <span style={{fontSize: 28, fontWeight: 700, color: "#1260D1", marginRight: 6}}>{`₪${round(
                    sumTotal,
                    2
                ).toLocaleString()}`}</span>
                <span style={{fontSize: 20, fontWeight: 700, color: "#1260D1"}}>+ VAT</span>
            </div>
        </div>
    );
};
